/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {printLocationQrCode} from '../api'

export const useMutationPrintLocationQrCode = createReactQueryMutationHook('printLocationQrCode', printLocationQrCode)
